<template>
  <div class="input-wrapper hd">
    <slot :condition="condition" :pickerOptions="pickerOptions" />
    <fragment v-if="[6, 7].includes(activity)">
      <div class="input-box">
        <span class="name">
          {{ routeName === 'coupon' ? '优惠券名称：' : '代金券名称：' }}
        </span>
        <div class="input">
          <el-input placeholder="请输入" v-model="condition.name" clearable />
        </div>
      </div>
      <div class="input-box">
        <span class="name">面额：</span>
        <div class="input">
          <el-select placeholder="请选择" v-model="condition.amount" clearable>
            <el-option
              :label="item.label"
              :value="item.value"
              :key="item.value"
              v-for="item in filterDownData('denominationList')"
            />
          </el-select>
        </div>
      </div>
      <div class="input-box" v-if="activeName !== '2'">
        <span class="name">是否禁用：</span>
        <div class="input">
          <el-select
            v-model="condition.activityState"
            placeholder="请选择"
            clearable
          >
            <el-option value="1" label="否" />
            <el-option value="2" label="是" />
          </el-select>
        </div>
      </div>
      <!-- <div class="input-box">
        <span class="name">发放对象：</span>
        <div class="input">
          <el-select v-model="condition.objects" placeholder="请选择" clearable>
            <el-option
              :value="item.value"
              :label="item.label"
              :key="item.value"
              v-for="item in filterDownData('levelList')"
            />
          </el-select>
        </div>
      </div> -->
    </fragment>
    <fragment v-if="[1, 2, 4, 8].includes(activity)">
      <div class="input-box">
        <span class="name">
          活动名称：
        </span>
        <div class="input">
          <el-input placeholder="请输入" v-model="condition.name" clearable />
        </div>
      </div>
      <div class="input-box">
        <span class="name">发放对象：</span>
        <div class="input">
          <el-select v-model="condition.objects" placeholder="请选择" clearable>
            <el-option
              :value="item.value"
              :label="item.label"
              :key="item.value"
              v-for="item in filterDownData('levelList')"
            />
          </el-select>
        </div>
      </div>
    </fragment>
    <fragment v-if="[3, 5].includes(activity)">
      <div class="input-box">
        <span class="name">
          商品名称：
        </span>
        <div class="input">
          <el-input placeholder="请输入" v-model="condition.name" clearable />
        </div>
      </div>
      <div class="input-box">
        <span class="name">
          商品SKU编码：
        </span>
        <div class="input">
          <el-input placeholder="请输入" v-model="condition.sku" clearable />
        </div>
      </div>
      <div class="input-box">
        <span class="name">
          销售价格：
        </span>
        <div class="input">
          <el-input
            placeholder="请输入"
            v-model="condition.startPrice"
            clearable
          />
        </div>
        至
        <div class="input">
          <el-input
            placeholder="请输入"
            v-model="condition.endPrice"
            clearable
          />
        </div>
      </div>
      <div class="input-box">
        <span class="name">
          发放对象：
        </span>
        <div class="input">
          <el-select placeholder="请选择" v-model="condition.objects" clearable>
            <el-option
              :label="item.label"
              :value="item.value"
              :key="item.value"
              v-for="item in filterDownData('levelList')"
            />
          </el-select>
        </div>
      </div>
      <div class="input-box">
        <span class="name">店铺分类：</span>
        <div class="input">
          <el-cascader
            placeholder="请选择"
            v-model="condition.merchantCategory"
            :options="filterDownData('goodsClass').options"
            clearable
          />
        </div>
      </div>
    </fragment>
    <div class="input-box datepick">
      <span class="name">
        {{ [3].includes(activity) ? '组合上架时间：' : '有效时间：' }}
      </span>
      <div class="input">
        <el-date-picker
          v-model="condition.time"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          clearable
          :picker-options="pickerOptions"
        />
      </div>
    </div>
    <el-button
      size="60"
      class="iconfont icon-sousuo"
      round
      @click="searchData"
    />
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import filterDownData from 'mixins/filterDownData'
// activity 取值 1 折扣 2 秒杀 3 组合 4 积分 5 团购 6 代金券 7 优惠券
export default {
  name: 'SearchComponent',
  mixins: [pickerOptions, filterDownData],
  props: {
    condition: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    },
    activeName: {
      type: String
    },
    activity: {
      type: Number
    }
  },
  methods: {
    /**
     * 搜索
     */
    searchData() {
      const condition = this._returnSearchConditon()
      this.$emit('updateData', vm => {
        vm._getActiveityList(condition)
      })
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchConditon() {
      const {
        name,
        time,
        amount,
        activityState,
        objects,
        sku,
        startPrice,
        endePrice,
        merchantCategory
      } = this.condition
      const activity = this.activity
      let data = {
        activity_type: this.activity,
        activity_title: name,
        effective_state: this.activeName,
        start_time: time && time[0],
        end_time: time && time[1],
        level_id: objects
      }
      if ([6, 7].includes(activity)) {
        data = {
          ...data,
          denomination_id: amount,
          activity_state: activityState
        }
      }
      if ([3, 5].includes(activity)) {
        data = {
          ...data,
          goods_sku: sku,
          start_price: startPrice,
          end_price: endePrice,
          goods_class: merchantCategory
        }
      }
      this.utils._checkSearchCondition(data)
      return data
    }
  }
}
</script>
